import { RedirectruleRedirectrule } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class RedirectRule<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Gets the feature version data.
	 *
	 * @tags Redirect Rule
	 * @name RedirectRuleFindByOriginalUrlKeywordIds
	 * @summary Get feature version data
	 * @request GET:/store/{storeId}/seo/redirectrule
	 * @secure
	 * @response `200` `RedirectruleRedirectrule` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	redirectRuleFindByOriginalUrlKeywordIds = (
		storeId: string,
		query: {
			/** The query name. */
			q: 'byOriginalUrlKeywordIds';
			/** The keyword ID. */
			origUrlKeywordId: string[];
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['redirectRuleFindByOriginalUrlKeywordIds'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/seo/redirectrule`,
				params: _params,
				query: query,
				methodName: 'redirectRuleFindByOriginalUrlKeywordIds',
			};
			logger.trace(traceData);
		}
		return this.http.request<RedirectruleRedirectrule, void>({
			path: `/store/${storeId}/seo/redirectrule`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
